export default (theme: Object) => ({
  root: {
    background: theme.palette.secondary.main,
    marginBottom: '20%',
  },
  icon: {
    color: theme.palette.neutrals.background,
  },
});
